import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/onramp-logo-white-with-text.svg'
import _imports_1 from '../assets/social-twitter.svg'
import _imports_2 from '../assets/social-linkedin.svg'


const _withScopeId = n => (_pushScopeId("data-v-01673d77"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mb-4" }
const _hoisted_4 = { class: "col-6" }
const _hoisted_5 = { class: "col-6 text-end" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "line-break" }, null, -1))
const _hoisted_7 = { class: "row mt-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 align-center-when-small" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "bs-bold item" }, "Onramp"),
  /*#__PURE__*/_createElementVNode("span", { class: "bs-reg item" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "bs-reg" }, "©"),
    /*#__PURE__*/_createTextVNode(" 2022 All Rights Reserved. ")
  ])
], -1))
const _hoisted_9 = { class: "col-sm-6 text-end align-center-when-small" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            target: "_blank",
            class: "item link",
            src: _imports_0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToLink(_ctx.homePage)))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            target: "_blank",
            class: "item link",
            src: _imports_1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToLink(_ctx.twitter)))
          }),
          _createElementVNode("img", {
            class: "item link",
            src: _imports_2,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToLink(_ctx.linkedin)))
          })
        ])
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("a", {
            href: _ctx.privacyPolicy,
            target: "_blank",
            class: "item link"
          }, "Privacy Policy", 8, _hoisted_10),
          _createElementVNode("a", {
            href: _ctx.tos,
            target: "_blank",
            class: "item link"
          }, "Terms of Service", 8, _hoisted_11)
        ])
      ])
    ])
  ]))
}